import type { PivotLayoutField } from '@ztechapps/common.contract'
import type { PivotData, PivotMember } from './types'
import { sortPivotMembers, toPivotMember, toPivotMemberKey } from './pivotMember.utils'

/** Lists the distinct members of a pivot field. */
export const listPivotMembers = ({
  data,
  field,
  timeZone,
}: {
  data: PivotData
  field: PivotLayoutField
  timeZone: string
}): PivotMember[] => {
  const pivotField = data.fields.find((item) => item.name === field.field)
  if (!pivotField) return []
  const index = data.fields.indexOf(pivotField)
  const seen = new Map<string, PivotMember>()
  data.rows.forEach((row) => {
    const key = toPivotMemberKey(row[index], pivotField, field.dateGroup, timeZone)
    // the label is built once per distinct member, not once per row
    if (!seen.has(key)) seen.set(key, toPivotMember(row[index], pivotField, field.dateGroup, timeZone))
  })
  return sortPivotMembers([...seen.values()].map((member) => ({ member }))).map((item) => item.member)
}
